// Module Import
//---------------------------------
import 'slick-carousel/slick/slick.scss'
import '../../../assets/css/slick-theme.scss'

import React from 'react'
import styled from 'styled-components'
import Slider from 'react-slick'
import IndustryPartnerCard from "../IndustryPartnerCard/IndustryPartnerCard";

// Component Import
//---------------------------------

// Styled Component Declarations
//---------------------------------
const GalleryCarouselWrapper = styled.div`
  border-radius: 4px;
  position: relative;
  //height: 100%;

  .slick-slider {
    display: flex;
    flex-direction: column;
    height: 100%;

    .slick-track {
      height: 100%;
      display: flex;
      align-items: center;

      .slick-slide > div {
        height: 100%;
      }
    }
  }
`

const Slide = styled.div`
  padding: 12px;
  height: fit-content;
  width: fit-content;
  display: flex;
`

// Component Export
//---------------------------------
export default function IndustryCarousel({ carouselImages }) {
  const carouselSettings = {
    dots: false,
    infinite: true,
    slidesToShow: 6,
    variableWidth: true,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 10000,
    cssEase: 'linear',
    pauseOnFocus: false,
    pauseOnHover: true,
    // responsive: [
    //   {
    //     breakpoint: 1800,
    //     settings: {
    //       slidesToShow: 4,
    //       slidesToScroll: 1,
    //     },
    //   },
    //   {
    //     breakpoint: 1400,
    //     settings: {
    //       slidesToShow: 3,
    //       slidesToScroll: 1,
    //     },
    //   },
    //   {
    //     breakpoint: 768,
    //     settings: {
    //       slidesToShow: 1,
    //       slidesToScroll: 1,
    //     },
    //   },
    // ],
  }

  return (
    <GalleryCarouselWrapper>
      <Slider {...carouselSettings}>
        {carouselImages.map(({id, ...rest}) => (
          <Slide key={id}>
            <IndustryPartnerCard {...rest} />
          </Slide>
        ))}
      </Slider>
    </GalleryCarouselWrapper>
  )
}
